import { LIST_REQUIRED_STATUSES } from "../../required-values";

export default {
    MISSING_EMAIL_FIELD_ERROR: {
        TITLE: 'Campo faltante para la dirección de correo electrónico',
        MESSAGE: '¡Agregue al menos 1 campo para la dirección de correo electrónico!'
    },
    INVALID_INPUT_ERROR: {
        TITLE: 'Falta un campo obligatorio o un campo no es válido.',
        MESSAGE: '¡Revise el formulario en busca de mensajes de error!'
    },
    MISSING_BOOKING_TIME_ERROR: {
        TITLE: 'Falta tiempo de reserva',
        MESSAGE: '¡Agregue la hora de reserva (hora de inicio y hora de finalización)!'
    },
    MISSING_SIGNATURE_ERROR: {
        TITLE: 'Un documento no está firmado',
        MESSAGE: '¡Revise el formulario en busca de mensajes de error y firme todos los documentos!'
    },
    INPUT_CONDITION_ERROR: {
        TITLE: 'Un campo de entrada no es válido',
        MESSAGE: 'Hay un campo de entrada que no es válido'
    },
    BUILDER_NO_FIELD_ERROR: {
        TITLE: 'No hay campo para el constructor',
        MESSAGE: '¡Agregue al menos un campo!'
    },
    EXCLUSIVE_OPTIONS_USE_SAME_VALUE: {
        TITLE: 'No se puede usar la misma opción entre {0} y {1}',
        MESSAGE: 'Por favor, anule la selección de la(s) opción(es) {2} en {0} o {1}'
    },
    MISSING_DEPENDENCY_OBJECT_ERROR: {
        TITLE: '¡Agregue más {0}!',
        MESSAGE: 'Debe tener al menos {1} {0}'
    },
    MISSING_EXPERIENCE_ERROR: {
        TITLE: 'Falta experiencia',
        MESSAGE: 'Debes tener al menos 1 experiencia.'
    },
    MISSING_STATUS_ERROR: {
        TITLE: 'Falta estado',
        MESSAGE: `${LIST_REQUIRED_STATUSES.join(" y ")} son estados obligatorios`
    },
    DUPLICATE_STATUS_ERROR: {
        TITLE: 'Estados duplicados',
        MESSAGE: 'Hay algunos estados que están duplicados'
    },
    DUPLICATE_MODEL_ERROR: {
        TITLE: 'Múltiples campos usando el mismo modelo',
        MESSAGE: 'Hay un modelo que está asignado a al menos 2 campos'
    },
    DUPLICATE_CHECKLIST_ITEM_ERROR: {
        TITLE: 'Estados duplicados',
        MESSAGE: 'Hay algunos elementos que están duplicados'
    },
    DUPLICATE_EMPLOYER_TYPE_ERROR: {
        TITLE: 'El tipo de empleador está duplicado',
        MESSAGE: 'Hay algunos tipos de empleadores que están duplicados'
    },
    DUPLICATE_CANDIDATE_TYPE_ERROR: {
        TITLE: 'El tipo de candidato está duplicado',
        MESSAGE: 'Hay algunos tipos de candidatos que están duplicados'
    },
    DUPLICATE_JOB_TYPE_ERROR: {
        TITLE: 'Los tipos de trabajo están duplicados',
        MESSAGE: 'Hay algunos tipos de trabajo que están duplicados'
    },
    INVALID_IMAGE_FILE_TYPE_ERROR: {
        TITLE: '¡Lo siento, ese tipo de archivo no es válido!',
        MESSAGE: 'Cargue una imagen PNG o JPG.'
    },
    INVALID_DOC_FILE_TYPE_ERROR: {
        TITLE: '¡Lo siento, ese tipo de archivo no es válido!',
        MESSAGE: 'Cargue un archivo DOC, DOCX o PDF.'
    },
    EMPTY_FILE_ERROR: {
        TITLE: '¡El archivo está vacío!',
        MESSAGE: 'Cargue un archivo que no esté vacío'
    },
    FILE_SIZE_EXCEED_LIMIT_ERROR: {
        TITLE: '¡Archivo demasiado grande!',
        MESSAGE: 'Cargue un archivo con un tamaño inferior al tamaño máximo de carga'
    },
    INVALID_INPUT_FILE: {
        TITLE: 'Archivo no válido',
        MESSAGE: 'Archivo de entrada no válido'
    },
    MISSING_RESUME_ERROR: {
        TITLE: 'Falta tu currículum profesional de cuidado de niños',
        MESSAGE: 'Cargue su currículum profesional de cuidado de niños'
    },
    END_DATE_BEFORE_START_DATE_ERROR: {
        TITLE: 'La fecha de finalización debe ser posterior a la fecha de inicio',
        MESSAGE: 'Por favor, cambie la fecha de inicio o la fecha de finalización'
    },
    END_HOUR_BEFORE_START_HOUR_ERROR: {
        TITLE: 'La hora de finalización debe ser posterior a la hora de inicio',
        MESSAGE: 'Por favor, cambie la hora de inicio o la hora de finalización'
    },
    BOOKING_DURATION_TOO_SHORT_ERROR: {
        TITLE: 'Las reservas deben ser de al menos {0} horas.',
        MESSAGE: 'Por favor, cambie la hora de inicio o la hora de finalización'
    },
    MISSING_PROFILE_PICTURE_ERROR: {
        TITLE: 'Falta tu foto de perfil',
        MESSAGE: '¡Sube una foto tuya reciente!'
    },
    NO_TEXT_SELECT: {
        TITLE: 'Ningún texto seleccionado',
        MESSAGE: 'Seleccione algún texto'
    },
    SUBMIT_REFERENCE_ERROR: {
        TITLE: '¡Su solicitud ha sido enviada! PERO',
        MESSAGE: 'Hubo un error al procesar sus referencias. ¿Puedes por favor enviárnoslos por correo electrónico? ¡Gracias!'
    },
    SUBMIT_ERROR: {
        TITLE: 'Error al enviar su solicitud',
        MESSAGE: 'Hubo un error al procesar su solicitud'
    },
    MISSING_ITEM_IN_JOB_STATUS_LIST: {
        TITLE: 'Elemento faltante en la lista de estado',
        MESSAGE: 'El estado {0} es obligatorio'
    },
    HAS_INCOMPLETE_SECTION: {
        TITLE: 'Hay una sección incompleta',
        MESSAGE: 'La sección {0} está incompleta. Por favor actualice esa sección'
    },
    CONTRASEÑA_UNMATCH_ERROR: {
        TITLE: 'Las contraseñas no coinciden.'
    },
    MISSING_ADDRESS_ERROR_DIALOG: {
        TITLE: 'No se pueden encontrar candidatos cercanos',
        MESSAGE: 'Al trabajo le falta una dirección completa. Para buscar candidatos, edite el trabajo y complete la información de la dirección que falta.'
    },
    PROFILE_BUILDER_IN_USED: {
        TITLE: 'El generador de perfiles está en uso',
        MESSAGE: 'El creador de perfiles está siendo utilizado por el creador de perfiles {0}.\n' +
            'Elimine primero ese creador de perfiles'
    },
    MISSING_SIGNATURE_ERROR_DIALOG: {
        TITLE: 'Falta una firma',
        MESSAGE: 'Escriba su nombre para firmar'
    },
    MISSING_REQUIRED_FIELD_SIGNING_ERROR_DIALOG: {
        TITLE: 'Falta un campo obligatorio',
        MESSAGE: 'Complete todos los campos obligatorios (consulte los campos con borde rojo)'
    },
    USER_EXISTED_ERROR_DIALOG: {
        INNER_HTML: `
        <h2>¡Parece que ya está en nuestro sistema!</h2>
        <h4 class="mensaje-de-error-mensaje-principal">
        Por favor, <a href='{0}/login/{1}'>inicie sesión en su panel de control</a> para continuar, o comuníquese con nosotros si tiene preguntas. ¡Gracias!
        </h4>
        `
    },
    WEEK_AVAILABILITY_BLOCK_END_TIME_BEFORE_START_TIME_ERROR: {
        TITLE: 'La hora de finalización debe ser posterior a la hora de inicio',
        MESSAGE: 'Cambie la hora de inicio o la hora de finalización del bloque {0} de {1}'
    },
    WEEK_AVAILABILITY_DURATION_TOO_SHORT_ERROR: {
        TITLE: 'El bloque debe ser de al menos {0} horas.',
        MESSAGE: 'Cambie la hora de inicio o la hora de finalización del bloque {1} de {2}'
    },
    WEEK_AVAILABILITY_EMPTY_REQUIRED_FIELD_ERROR: {
        TITLE: 'Campo obligatorio vacío',
        MESSAGE: 'Indique la hora de inicio y la hora de finalización del bloque {0} de {1}'
    },
    PAYMENT_INFORMATION_REQUIRED: {
        TITLE: "Se requiere información de pago",
        MESSAGE: "Ingrese la información de pago"
    },
    INVALID_PAYMENT_INFORMATION: {
        TITLE: "Información de pago no válida",
        MESSAGE: "Actualice la información de pago: {0}"
    },
    LIST_INPUT_CONTAINS_BLANK: {
        TITLE: "{0} contiene un valor en blanco",
        MESSAGE: "Elimine el espacio en blanco {0}"
    },
    DUPLICATE_HEADER_IMPORT_CSV: {
        TITLE: "Hay algunos encabezados duplicados.",
        MESSAGE: "Lista de encabezados duplicados: {0}.\nSi se importan los encabezados duplicados, es posible que no se importen los campos correspondientes"
    },
    CANNOT_EDIT_BOOKING_WITHIN_X_HOURS: {
        TITLE: "No se puede editar la reserva",
        MESSAGE: "Lo sentimos, el cambio no se puede hacer menos de {0} horas antes de que comience un trabajo. Si necesita un cambio, contáctenos directamente. ¡Gracias!"
    },
    CANNOT_ADD_BOOKING_WITHIN_X_HOURS: {
        TITLE: "No se puede agregar la reserva",
        MESSAGE: "Lo sentimos, no se puede reservar menos de {0} horas antes de que comience un trabajo. Si realmente necesita esto, contáctenos directamente. ¡Gracias!"
    },
    PAYMENT_FIELD_REQUIRED_IN_APPLICATION_FORM: {
        TITLE: "El campo de pago es obligatorio",
        MESSAGE: "Agregue un campo de pago para poder cobrar al usuario cuando envíe el formulario de solicitud"
    },
    MISSING_NUMBER_OF_ROWS: {
        TITLE: 'Por favor, especifique el número de filas para la importación parcial'
    },
    SCHEDULE_CONFLICT_CANDIDATE_ERROR_DIALOG: {
        TITLE: "Conflicto de horario",
        MESSAGE: "Ya estás asignado a otro trabajo durante ese tiempo"
    },
    CLIENT_CONFIRM_INCORRECT_PASSWORD: {
        TITLE: "Contraseña incorrecta",
        MESSAGE: "Error al aprobar la hora de entrada/salida. La contraseña del cliente es incorrecta"
    }
}


// WEBPACK FOOTER //
// ./src/constants/multi-languages/error-dialog/es.js